export default __webpack_public_path__ + "static/media/requestQuotation.abf62f62.svg";